<template>
  <div class="bg">
    <div class="ty">
      <p style="color:white;font-size:60px;">ขอบคุณ</p>
      <p style="color:white;font-size:35px">ที่เข้าร่วมกิจกรรม</p>
    </div>
  </div>
</template>

<script>
export default {
  mounted(){
    console.log(this.$store.state.form)
  }
};
</script>

<style scoped>
.bg {
  /* background-image: url("../assets/background.jpg"); */
  background-repeat: no-repeat;
  background-size: 450px;
  height: 100vh;
}
.rank1 {
  position: absolute;
  margin-left: 15px;
  margin-top:15px;
}
.rank2 {
  position: absolute;
  margin-top: 230px;
  margin-left: 45%;
}
.rank3 {
  position: absolute;
  margin-top: 370px;
  margin-left: 15px;
}
.rank4 {
  position: absolute;
  margin-top: 520px;
  margin-left: 45%;
}
.ty {
  padding-top: 250px;
  color:white;
}
.text1{
  margin-top:-150px;
  font-size: 30px;
}
.text2{
  margin-top: -120px;
  font-size: 30px;
}
.text3{
  margin-top: -120px;
  font-size: 30px;
}
.text4{
  margin-top: -120px;
  font-size: 30px;
}
</style>